import type { VideoModelConfig } from '../../types';

/** Seedance 2.0 Fast（行为与 Seedance 2.0 一致） */
export const seedance2_0Fast: VideoModelConfig = {
  id: '01M21ZPA48AFCXSNS39FKKQ8FJ',
  displayName: 'Seedance 2.0 Fast',
  defaults: {
    ratio: '9:16',
    resolution: '720P',
    duration: 5,
    sound: 'on',
  },
  ratioOptions: [
    { label: '1:1', value: '1:1' },
    { label: '3:4', value: '3:4' },
    { label: '4:3', value: '4:3' },
    { label: '9:16', value: '9:16' },
    { label: '16:9', value: '16:9' },
    { label: '21:9', value: '21:9' },
    { label: '自适应', value: 'adaptive' },
  ],
  resolutionOptions: [
    { label: '480P', value: '480P' },
    { label: '720P', value: '720P' },
  ],
  duration: { mode: 'range', min: 4, max: 15, step: 1, default: 5 },
  capabilities: {
    refVideo: true,
    refAudio: true,
    sound: true,
    realVideo: true,
    multiModalReference: true,
    multiVideo: true,
  },
  limits: {
    maxRefImages: 9,
    maxRefVideos: 3,
    maxRefAudios: 3,
    // 参考视频上传约束：格式 mp4/mov、单文件 ≤50MB、时长 [3,15]s
    //（Seedance 2.0/2.0 Fast 视频参考上限 50MB、2.5 为 200MB，产品逻辑如此，非漏判）
    refVideoConstraints: {
      formats: ['mp4', 'mov'],
      maxFileSizeMB: 50,
      duration: { min: 3, max: 15 },
      hintKey: 'imageCreation.videoUploadHint',
    },
    // 参考音频上传约束（转写自 AudioSelectModal 原硬编码）：格式 wav/mp3、单文件 ≤15MB、时长 [2,15]s
    refAudioConstraints: {
      formats: ['wav', 'mp3'],
      maxFileSizeMB: 15,
      duration: { min: 2, max: 15 },
      hintKey: 'imageCreation.audioUploadHint',
    },
  },
  /** 画布扩展（节点式业务专属字段，从画布 configs/seedance-2.0-fast.ts 迁移；画布版 limits 值可能与 feed 不同） */
  canvas: {
    defaults: {
      realVideo: true,
      audioSync: true,
    },
    toggles: {
      realVideo: true,
      audioSync: true,
    },
    capabilities: {
      refVideo: true,
      refAudio: true,
      atMentionTabs: ['全能参考', '图生视频', '视频编辑', '视频延长'],
    },
    limits: {
      validateRefImageSize: true,
      promptMaxLength: 12000,
      maxRefImages: 9,
      maxRefVideos: 3,
      maxRefAudios: 3,
      refImageConstraints: {
        formats: ['jpeg', 'png', 'webp', 'bmp', 'tiff', 'gif'],
        maxFileSizeMB: 30,
        dimension: { min: 300, max: 6000 },
        aspectRatio: { min: 0.4, max: 2.5 },
      },
      refVideoConstraints: {
        formats: ['mp4', 'mov'],
        maxFileSizeMB: 200,
        duration: { min: 2, max: 15, totalMax: 15 },
        pixelCount: { min: 409600, max: 8295044 },
        dimension: { min: 300, max: 6000 },
        aspectRatio: { min: 0.4, max: 2.5 },
      },
      refAudioConstraints: {
        formats: ['wav', 'mp3'],
        maxFileSizeMB: 15,
        duration: { min: 2, max: 15, totalMax: 15 },
      },
    },
  },
};
